/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type { HelpCenterSettingsEmailAppWithLayout as HelpCenterSettingsEmailType } from '@jira/spa-apps__help-center-settings-email/src/HelpCenterSettingsEmailAppWithLayout.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { usePathParam } from '@atlassian/react-resource-router';

export const LazyHelpCenterSettingsEmail: LazyComponent<typeof HelpCenterSettingsEmailType> =
	lazyForPaint<typeof HelpCenterSettingsEmailType>(
		() =>
			import(
				/* webpackChunkName: "async-help-center-settings-email", jiraSpaEntry: "async-help-center-settings-email" */ '@jira/spa-apps__help-center-settings-email/src/HelpCenterSettingsEmail.tsx'
			),
	);

export const HelpCenterSettingsEmail = (): React.JSX.Element => {
	const [helpCenterId] = usePathParam('helpCenterId');
	return (
		<LazyPage
			// Emails does not handle projectKey changes so we're passing the helpCenterId as a key to force a re-render
			key={helpCenterId}
			Page={LazyHelpCenterSettingsEmail}
			pageId="help-center-settings-email"
			shouldShowSpinner
		/>
	);
};
